import * as React from 'react';
import { Card, CardBody, CardTitle, ExpandableSection, Title } from '@patternfly/react-core';

interface SectionCardProps {
  id: string;
  title: string;
  hint: string;
  isExpanded: boolean;
  onToggle: (isExpanded: boolean) => void;
  isStatic?: boolean;
  children: React.ReactNode;
}

export const SectionCard: React.FunctionComponent<SectionCardProps> = ({
  id,
  title,
  hint,
  isExpanded,
  onToggle,
  isStatic = false,
  children,
}) => (
  <section id={id} className="risk-register__section" aria-labelledby={`${id}-title`}>
    <Card className={`risk-register__section-card${isStatic ? ' risk-register__section-card--static' : ''}`}>
      <CardTitle>
        <Title headingLevel="h2" size="lg" id={`${id}-title`}>
          {title}
        </Title>
        <p className="risk-register__section-hint">{hint}</p>
      </CardTitle>
      {isStatic ? (
        <CardBody>{children}</CardBody>
      ) : (
        <ExpandableSection
          toggleTextExpanded="Collapse section"
          toggleTextCollapsed="Expand section"
          isExpanded={isExpanded}
          onToggle={(_event, expanded) => onToggle(expanded)}
        >
          <CardBody>{children}</CardBody>
        </ExpandableSection>
      )}
    </Card>
  </section>
);
